/* eslint-disable no-console */
import { isTrue } from '@src/utils/bool.utils'
import { getQuery, isCloud } from '@src/utils/url.utils'
import { defaultHandleStatus, handleErrors } from './helpers'

export interface InfoResponse {
  tokenEndpoint?: string
  tenantName?: string
  authorizeEndpoint?: string
  tenantId?: string
}

const getOAuthProvider = () => {
  if (window.__OAUTH_PROVIDER__) {
    return window.__OAUTH_PROVIDER__
  }
  return null
}

const getClientID = () => {
  if (window.__OAUTH_CLIENT_ID__) {
    return window.__OAUTH_CLIENT_ID__
  }
  return isCloud() ? 'cam-ui-dev' : 'cam-ui'
}

function getEnabledSSO() {
  const params = getQuery()
  const ssoKey = 'sso'
  if (Object.keys(params).includes(ssoKey)) {
    return isTrue(params[ssoKey])
  }
  return window.__ENABLE_SSO__
}

const getOAuthCodeProvider = () => {
  if (window.__OAUTH_PROVIDER_CODE__) {
    return window.__OAUTH_PROVIDER_CODE__
  }
  return null
}

export const getOauthInfo = async (res): Promise<InfoResponse> => {
  const urlRequest = `${res?.idn_api_url}/oauth/info`

  return fetch(urlRequest, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(handleErrors())
    .then((res: Response) => {
      try {
        return res.json<InfoResponse>().catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
    .then(res => defaultHandleStatus(res, null, true))
    .then(res => res)
    .catch(ex => ex)
}

export const CLIENT_ID = getClientID()
export const ENABLE_SSO = getEnabledSSO()
export const OAUTH_PROVIDER = getOAuthProvider()
export const OAUTH_PROVIDER_CODE = getOAuthCodeProvider()
